<template>
  <div class="block-wrap">
    <BlockTitle title-type="city">
      <!--<div>更多城市》</div>-->
    </BlockTitle>
    <div class="content-wrap">
      <div class="intro-box">
        <h3 class="title">{{ activeItem.name }}</h3>
        <div class="desc">{{ activeItem.desc }}</div>
        <!--<div class="card-more">查看详情</div>-->
      </div>
      <div class="view-box">
        <div class="card-list-wrap" :style="listWrapStyle">
          <div
            class="card-item"
            :class="activeIndex === index ? 'active' : ''"
            @click="onCardClick(index)"
            v-for="(item, index) in cardList"
            :key="index"
          >
            <img class="card-img" :src="item.imgSrc" alt="" />
            <div class="cover">
              <div class="cover-bg"></div>
              <div class="card-text-en">{{ item.en }}</div>
              <div class="card-text-zh">{{ item.title }}</div>
            </div>
          </div>
        </div>
        <div class="prev-button" @click="onPrev()"></div>
      </div>
    </div>
    <SplitLine />
  </div>
</template>

<script>
import BlockTitle from "@/components/BlockTitle";

import hz from '../../assets/tempImages/index/hz.jpg';
import wz from '../../assets/tempImages/index/wz.jpg';
import zs from '../../assets/tempImages/index/zs.jpg';
import jh from '../../assets/tempImages/index/jh.jpg';
import nb from '../../assets/tempImages/index/nb.jpg';
import sx from '../../assets/tempImages/index/sx.jpg';
import fyq from '../../assets/tempImages/index/fyq.jpg';
import jx from '../../assets/tempImages/index/jx.jpg';
import huzhou from '../../assets/tempImages/index/huzhou.jpg';
import tx from '../../assets/tempImages/index/tx.jpg';
import zj from '../../assets/tempImages/index/zj.jpg';
import lh from '../../assets/tempImages/index/lh.jpg';
import aj from '../../assets/tempImages/index/aj.jpg';
import yw from '../../assets/tempImages/index/yw.jpg';
import sy from '../../assets/tempImages/index/sy.jpg';
import tz from '../../assets/tempImages/index/tz.jpg';
import qz from '../../assets/tempImages/index/qz.jpg';
import yy from '../../assets/tempImages/index/yy.jpg';
import jiashan from '../../assets/tempImages/index/jiashan.jpg';
import ph from '../../assets/tempImages/index/ph.jpg';
import hn from '../../assets/tempImages/index/hn.jpg';


import cs1 from '../../assets/tempImages/cs1.jpg';
import cs2 from '../../assets/tempImages/cs2.jpg';
import cs3 from '../../assets/tempImages/cs3.jpg';
import cs4 from '../../assets/tempImages/cs4.jpg';

export default {
  data() {
    return {
      cardList: [],
      activeIndex: 0,
    };
  },
  computed: {
    activeItem() {
      if (!this.cardList.length) return {};
      return this.cardList[this.activeIndex];
    },
    listWrapStyle() {
      return `right: -${(this.cardList.length - 1 - this.activeIndex) * 320}px`;
    },
  },
  components: {
    BlockTitle,
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const res = [
        {
          title: "杭州",
          name: "杭州",
          desc: "杭州地处中国华东地区、钱塘江下游、东南沿海、浙江北部、京杭大运河南端，杭州人文古迹众多，西湖及其周边有大量的自然及人文景观遗迹，具代表性的有西湖文化、良渚文化、丝绸文化、茶文化。因风景秀丽，素有“人…",
          en: "Hangzhou",
          imgSrc: hz
        },
        {
          title: "温州",
          name: "温州",
          desc: "温州风景名胜区，位于浙江省杭州市中心，分为湖滨区、湖心区、北山区、南山区和钱塘区；秀丽的湖光山色和众多的名胜古迹闻名中外，是中国著名的旅游胜地，也被誉为人间天堂。景区内群山高度都不超过400米。",
          en: "Wenzhou",
          imgSrc: wz
        },
        {
          title: "舟山",
          name: "舟山",
          desc: "舟山，位于浙江省杭州市中心，分为湖滨区、湖心区、北山区、南山区和钱塘区；秀丽的湖光山色和众多的名胜古迹闻名中外，是中国著名的旅游胜地，也被誉为人间天堂。景区内群山高度都不超过400米。",
          en: "Zhoushan",
          imgSrc: zs
        },
        {
          title: "金华",
          name: "金华",
          desc: "金华，位于浙江省杭州市中心，分为湖滨区、湖心区、北山区、南山区和钱塘区；秀丽的湖光山色和众多的名胜古迹闻名中外，是中国著名的旅游胜地，也被誉为人间天堂。景区内群山高度都不超过400米。",
          en: "Jinhua",
          imgSrc: jh
        },
        {
          title: "宁波",
          name: "宁波",
          desc: "宁波是我国东南沿海重要的现代化国际港口城市，自1996年市委、市政府提出第一个“绿化年”以来，城市园林绿化得到了迅猛发展。2004年1月被国家建设部命名为国家园林城市，2009年顺利通过住建部的复查，继续蝉联国家园林城市称号。截止2012年底，宁波市建成区面积289.83平方公里，城区绿化覆盖面积11080公顷,绿化覆盖率38.23%，园林绿地面积10113公顷，绿地率34.89%，公园绿地1853公顷，公园106个，人均公园绿地面积10.56平方米。",
          en: "Ningbo",
          imgSrc: nb
        },
        {
          title: "绍兴",
          name: "绍兴",
          desc: "绍兴市地处长江三角洲南翼，浙江省中北部，西接杭州，东临宁波，北濒杭州湾，面积8256平方公里，人口446万，其中绍兴市区建成区面积114.71平方公里，人口77.96万人。绍兴是国务院首批公布的24个历史文化名城之一，是著名的水乡、桥乡、酒乡、兰乡、书法之乡、名士之乡，素有“山青水秀之乡、历史文物之邦、名人荟萃之地”的美誉，毛泽东主席称绍兴为“鉴湖越台名士乡”。绍兴先后荣获中国优秀旅游城市、国家卫生城市、国家环保模范城市、国家园林城市、国家节水型城市、中国人居环境奖和联合国人居奖等称号。",
          en: "Shaoxing",
          imgSrc: sx
        },
        {
          title: "富阳区",
          name: "富阳区",
          desc: "富阳山青水秀，景色绮丽，既赋山城之美，又具江城之秀，是座典型的江南山水城市。城在山水中，园林在城中，山城相连，郊野相通，景点遍布，风景宜人的江南山水园林更是富阳城市的特色。结合周围大环境和“天下独绝”的富春江、河道水系，形成城市绿色生态系统。并以公园绿化为主体、道路江河绿化为支撑、单位绿化为依托、小区绿化为基础的“点、线、面”结合、平面立体相融的山水园林城市格局。多年来，富阳十分重视开展城市绿化工作，对城市规划区范围内的江河湿地等进行了有效保护，对城中山四周作了建筑限制，并对历史形成的一些遭到破坏的山体进行有效的生态修复，充分发挥江城优势，突出城市历史文化宣染。经过不懈的努力，富阳于2003年12月被命名为国家园林城市，成为全国首批迈入国家园林城市行列的县级市。并在2009年成功通过了国家园林城市的复评。",
          en: "Fuyang",
          imgSrc: fyq
        },
        {
          title: "嘉兴",
          name: "嘉兴",
          desc: "嘉兴是水乡特色鲜明的城市。近年来在推进城市园林绿化建设中，嘉兴市按照科学发展观的要求，始终坚持以“生态立市”为指导，以城市创建为抓手，以重点实施“公园提升”、“城市绿荫”、“三清两绿”、“生态绿道”等工程建设为载体，因地制宜、挖掘独有资源、做足做好“水、绿、文”三篇文章，市区先后建成了南湖风景名胜公园、范蠡湖公园、春晓公园、石臼漾湿地、凌公塘公园、中央公园等公园绿地，并充分利用良好的城市自然水网骨架，形成了嘉兴鲜明的水系园林景观。至2012年底，嘉兴市区建成区绿化覆盖率、绿地率分别为43.87%和41.93%，绿地面积、公园绿地面积、人均公园绿地面积分别为3766.67公顷、995.73公和13.99平方米。各类公园数量共50个，合理分布于市内各不同的区块，借助河流、道路网络，通过合理的服务半径层层渗透，进一步发挥其综合功能，更好地满足市民游憩健身需要。目前嘉兴市建成了“一心、三环、三园、三楔、八带”的城市绿地系统，基本形成绿量总量稳定、生态系统良好、布局合理的总体绿地格局，充分体现了清雅、灵秀、简约的水乡城市风格，塑造了“水都绿城”与“越韵吴风”相得益彰的园林城市特色。",
          en: "Jiaxing",
          imgSrc: jx
        },
        {
          title: "湖州",
          name: "湖州",
          desc: "湖州是一座具有2300多年历史的江南古城，位于浙江北部，太湖南岸，是环太湖地区唯一因湖得名的城市。湖州交通便利、区位优势。人文荟萃、文化深厚，山水清丽、环境优美，元代诗人戴表元以“行遍江南清丽地、人生只合住湖州”诗句来赞誉湖州的人居环境，这也是今日湖州的真实写照。",
          en: "Huzhou",
          imgSrc: huzhou
        },
        {
          title: "桐乡",
          name: "桐乡",
          desc: "桐乡历史悠久，人杰地灵，有千年水乡古镇乌镇和江南名刹福严禅寺，悠悠运河水哺育了一批名人贤士，相继建成茅盾故居、丰子恺缘缘堂、金仲华故居等名人场馆。桐乡是中国优秀旅游城市、国家卫生城市、国家园林城市，是中国杭白菊之乡、民间艺术（漫画）之乡。",
          en: "Tongxiang",
          imgSrc: tx
        },
        {
          title: "诸暨",
          name: "诸暨",
          desc: "诸暨市于2004年成功创建省级园林城市，2005年底顺利通过国家园林城市创建考核小组的实地验收，2006年9月获得国家园林城市光荣称号，2009年通过了建设部第一次复检，几年来，诸暨市继续围绕“巩固国家园林城市”，以建设山水园林城市为目标，科学规划，打造精品，统筹推进，着力提升城市品位。随“点”布绿，沿“线”增绿，借“面”扩绿，依“环”添绿，向“空”要绿，以“养”护绿，着力提升城市形象，全民参与，共创共建，着力提升城市文明。如今，诸暨市园林绿化指标逐年增长，城市园林绿化成效显著，至2012年底建成区绿化覆盖面积1336.52万平米，绿化覆盖率达42.56%，绿地面积1239.34万平米，绿地率达39.46%，公园绿地面积达282.28万平米，人均公共（公园）绿地面积10.57平米。",
          en: "Zhuji",
          imgSrc: zj
        },        
        {
          title: "临海",
          name: "临海",
          desc: "临海地处浙江省东南沿海中部，是一座具有2000多年历史的国家级历史文化名城，全市陆域面积2203平方公里，海域面积1819平方公里，总人口117万，其中市区建成区面积40.36平方公里，城市人口30.65万。临海依山面海，素有“山水名城，文化之邦”之称。",
          en: "Linhai",
          imgSrc: lh
        },
        {
          title: "安吉",
          name: "安吉",
          desc: "安吉县位于浙江西北部，地处长三角经济圈的几何中心，是浙江省极具特色的县。建县于公元185年，县名取《诗经》“安且吉兮”之意。全县总面积1886平方公里，常住人口46万，辖9镇4乡1街道1个省级经济开发区。位居中国十大竹乡之首，是著名的中国白茶之乡、中国椅业之乡、中国竹地板之都，被命名为全国首个国家生态县、国家卫生县城、全国文明县城，全国唯一县级“联合国人居环境奖”，两度蝉联“长三角最具投资价值县市（特别奖）”。2006年荣获国家园林县城称号。",
          en: "Anji",
          imgSrc: aj
        },
        {
          title: "义乌",
          name: "义乌",
          desc: "义乌是一座古城，建县于秦赢政25年，古称乌伤；义乌又是一座国际商贸城市---全球最大的小商品贸批发市场。义乌市地处长江三角洲南翼，辖6镇7街道，市域面积1105平方公里。截至2012年底，建成区面积100.1平方公里，绿地面积3264公顷，绿地率为32.61%，绿化覆盖面积3740公顷，绿化覆盖率为37.36%，公园绿地面积715公顷，人均公园绿地面积达10.06㎡/人。2008年2月被授予“国家园林城市”称号。",
          en: "Yiwu",
          imgSrc: yw
        },
        {
          title: "上虞",
          name: "上虞",
          desc: "上虞位于浙江省东北部，山川秀丽，历史悠久，有着深厚的文化底蕴和人文资源，城区含山纳水，自然条件十分优越，各类园林、绿地星罗棋布，连线成片，整座城市融山、水、城、园于一体，独具现代化山水园林城市特色。",
          en: "Shangyu",
          imgSrc: sy
        },
        {
          title: "台州",
          name: "台州",
          desc: "台州市（台，音tāi），位于浙江省沿海中部，上海经济区的南翼，是长三角经济圈16个城市之一，市中心处北纬28度，东经122度。北邻宁波、绍兴，南连温州，是中国黄金海岸线上一个新兴的组合式港口城市。全市陆地面积9413平方千米，浅海面积8万平方千米，人口约６００万，其中市区人口144万。台州名山古刹时掩时映，碧海蓝天云卷云舒，自有一派江南“海上仙子国”的明媚秀色。旅游以“佛、山、海、城、洞”五景最具特色，拥有国家重点风景名胜区天台山、温岭长屿硐天和国家级历史文化名城临海。地势由西向东倾斜，南面以雁荡山为屏，有括苍山、大雷山和天台山等主要山峰，其中括苍山主峰米筛浪高达1382.4米，是浙东最高峰。椒江水系由西向东流经市区入台州湾。",
          en: "Taizhou",
          imgSrc: tz
        },
        {
          title: "衢州",
          name: "衢州",
          desc: "衢州，位于浙江西部，钱塘江源头，地处浙、闽、赣、皖四省边界，属全国九个生态环境良好的地区之一，有“浙江绿源”之称。衢州府城怀抱峥嵘，襟带双江，作为一座人文积淀深厚的国家历史文化名城，因其禀赋独特的山水自然资源，在古朴、凝重中透现出清丽脱俗之姿，素有“神奇山水、名城衢州”的美誉。",
          en: "Quzhou",
          imgSrc: qz
        },
        {
          title: "余姚",
          name: "余姚",
          desc: "余姚，山清水秀、人杰地灵，自古即有“文献名邦”和“东南最名邑”之美誉。改革开放以来，经济社会高速发展，连续多年位列全国百强县（市）排行榜前十，中国最具幸福感城市（县级）。截止2012年底，余姚建成区绿地面积1721.35公顷，绿化覆盖率42.79%，绿地率37.78%，人均公共绿地面积10.07㎡；城区各类公园24个，人均公园绿地面积10.07㎡。2010年荣获“国家园林城市”称号，2011年喜摘联合国第六届“全球绿色城市”桂冠。",
          en: "Yuyao",
          imgSrc: yy
        },
        {
          title: "嘉善",
          name: "嘉善",
          desc: "嘉善县依托城市良好的自然环境和深厚的文化底蕴，全力打造“水在城中、城在林中、环境优美、特色鲜明”的绿色家园。以植物造景、自然生态、适度开发、合理利用为原则，注重选择和使用乡土植物，保护生物多样性，营建园林景观精品。结合城市功能布局，按照合理的服务半径，发展不同规模的户外公共绿色空间，扩大城市园林绿地面积，通过增加城市绿量，积极构建“一环双轴、五带多园”的城市绿地系统。",
          en: "Jiashan",
          imgSrc: jiashan
        },
        {
          title: "平湖",
          name: "平湖",
          desc: "平湖——杭州湾北岸的一颗璀璨明珠，素有“金平湖”的美誉。平湖市依山傍海，融丰沛水域、悠远文脉、经典园林于一体，是良渚文化的发源地，著名的瓜灯之城、叔同故里，是浙江省17个扩大经济管理权限的强县(市)之一，素有“鱼米之乡、瓜灯之城、文化之邦”的美称，被誉为中国童车之乡、服装制造名城。",
          en: "Pinghu",
          imgSrc: ph
        },
        {
          title: "海宁",
          name: "海宁",
          desc: "海宁——地处长江三角洲杭嘉湖平原，钱塘江北岸，是世界著名涌潮“钱江潮”的涌起之地。全市市域面积700.5平方公里，人口66.6万，市区建成区面积34.2平方公里，城市人口16.8万。",
          en: "Haining",
          imgSrc: hn
        },       
      ];
      const list = [];
      for (let i = res.length - 1; i >= 0; i--) {
        list.push(res[i]);
      }
      this.cardList = list;
      this.activeIndex = res.length - 1;
    },
    onCardClick(index) {
      this.activeIndex = index;
    },
    onPrev() {
      if (this.activeIndex === 0) {
        this.activeIndex = this.cardList.length - 1;
      } else {
        this.activeIndex--;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/less/global.less';

.block-wrap {
  overflow: hidden;
  
  .content-wrap {
    margin-top: 50px;
    margin-bottom: 57px;
    height: 480px;
    position: relative;

    .intro-box {
      width: 240px;
      height: 100%;
      padding-top: 80px;
      position: absolute;
      right: 0;
      top: 0;

      .title {
        height: 33px;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #131415;
        line-height: 33px;
        margin-bottom: 12px;
      }

      .desc {
        &:extend(.line6);
        height: 144px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131415;
        line-height: 24px;
        margin-bottom: 36px;
      }

      .card-more {
        width: 120px;
        height: 40px;
        line-height: 40px;
        background: #f1f3f3;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131415;
        text-align: center;
        cursor: pointer;

        &:hover {
          color: #06ae63;
        }
      }
    }

    .view-box {
      width: 1200px;
      height: 100%;
      position: absolute;
      right: 256px;
      top: 0;
      overflow: hidden;

      .card-list-wrap {
        height: 100%;
        padding: 0 20px;
        display: flex;
        align-items: flex-end;
        position: absolute;
        right: 0;
        top: 0;
        transition: all 0.4s ease-in;

        .card-item {
          width: 300px;
          height: 400px;
          flex: 1 1 auto;
          margin-left: 20px;
          position: relative;
          transition: height 0.4s ease-in;
          cursor: pointer;

          &.active {
            height: 480px;
            box-shadow: 0px 10px 20px 10px rgba(10, 35, 18, 0.08);
            border: 4px solid #06ae63;

            .cover {
              display: none;
            }
          }

          .card-img {
            display: block;
            width: 100%;
            height: 100%;
          }

          .cover {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .cover-bg {
              background: #0a2312;
              opacity: 0.35;
              width: 100%;
              height: 100%;
              position: absolute;
              left: 0;
              top: 0;
            }

            .card-text-en {
              font-size: 24px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: #fdfffd;
              line-height: 33px;
              margin-bottom: 4px;
            }

            .card-text-zh {
              font-size: 28px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: #fdfffd;
              line-height: 40px;
            }
          }
        }
      }

      .prev-button {
        width: 44px;
        height: 44px;
        background-image: url(../../assets/images/arrow.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        position: absolute;
        right: 0;
        top: 50%;
        transform: rotate(180deg) translateY(-22px);

        &:hover {
          background-image: url(../../assets/images/arrow-active.png);
        }
      }
    }
  }
}
</style>